/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import { PathName } from 'appConstants';
import { emailValidator } from 'utils';
import { authSelectors } from 'store/auth/selectors';
import { authSignIn } from 'store/auth/actionCreators';

import {
  Button,
  Input,
  toastError,
} from 'components';

import styles from './styles.module.scss';

export const SignInPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation('welcome');
  const trans = useTranslation('main').t;

  const isLoading = useSelector(authSelectors.getProp('isLoading'));

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const onClickRegister = useCallback(() => {
    navigate(PathName.Registration);
  }, [navigate]);

  const onClickForgotPassword = useCallback(() => {
    navigate(PathName.ForgotPassword);
  }, [navigate]);

  const onClickProfile = useCallback(() => {
    navigate(PathName.Profile);
  }, [navigate]);

  const onClickSignIn = useCallback(() => {
    const currentEmailError = emailValidator(email);
    if (currentEmailError) {
      toastError(t(currentEmailError));
      return;
    }
    dispatch(authSignIn({
      email,
      password,
      onCallback: onClickProfile,
    }));
  }, [
    t,
    dispatch,
    email,
    password,
    onClickProfile,
  ]);

  // eslint-disable-next-line max-len
  const handleKeyDown = useCallback((event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (event.key === 'Enter') {
      onClickSignIn();
    }
  }, [onClickSignIn]);

  return (
    <div>
      <div className={styles.main_content}>
        <div className={styles.main_half_first}>
          <div className={styles.main_title}>
            <p>{t('Sign_in_title_')}</p>
          </div>
          <div className={styles.main_subtitle}>
            <p>{t('Sign_in_subtitle_')}</p>
          </div>
          <div className={styles.main_form}>
            <Input
              value={email}
              onKeyDown={handleKeyDown}
              onChangeValue={setEmail}
              placeholder={t('Registration_form_email_')}
            />
            <Input
              value={password}
              onKeyDown={handleKeyDown}
              onChangeValue={setPassword}
              placeholder={t('Registration_form_password_')}
              isPassword
            />          
            {' '}
            <div className={styles.main_forgot_password}>
              <button onClick={onClickForgotPassword}>
                {t('Sign_in_forgot_password_')}
              </button>
            </div>
            <Button
              onClick={onClickSignIn}
              className={styles.main_btn}
              color="blue"
              isLoading={isLoading}
              disabled={!email || !password}
            >
              {trans('Enter_')}
            </Button>
          </div>
          <div className={styles.main_no_account_}>
            {t('main_no_account_')}
            {' '}
            <button
              onClick={onClickRegister}
              className={styles.main_no_account__btn}
            >
              {t('main_no_account_enter_')}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};
